import React, { ComponentType, ReactNode } from 'react';

type ProviderType = ComponentType | ((props: any) => JSX.Element);

export type Provider<P = { [key: string]: any }> = ProviderType | [ProviderType, P];

type Props = {
  providers: Provider[];
  children: ReactNode;
}

export default function FlatProvider({ providers, children }: Props) {
  return (
    <>
      {providers.reduce((acc, curr) => {
        const [Provider, props] = Array.isArray(curr) ? [curr[0], curr[1]] : [curr, {}];
        return <Provider {...props}>{acc}</Provider>;
      }, children)}
    </>
  );
}
